<template>
  <b-card title="مدیریت مشاوران">
    <b-row>
      <b-col class="table-size">
        <div class="custom-search">
          <b-row>
            <div class="filter-row">
              <b-button
                class="mb-1 mr-auto ml-1"
                variant="primary"
                @click="openAdd()"
              >
                جدید
              </b-button>
              <b-col md="2">
                <b-form-group
                  label="نام"
                  label-for="Title"
                >
                  <b-form-input
                    v-model="filterOptions.Title"
                    @keyup.enter="update(1)"
                  />
                </b-form-group>
              </b-col>
              <b-col md="2">
                <b-form-group
                  label="موبایل"
                  label-for="Mobile"
                >
                  <b-form-input
                    v-model="filterOptions.Mobile"
                    @keyup.enter="update(1)"
                  />
                </b-form-group>
              </b-col>
              <b-col md="2">
                <b-form-group
                  label="وضعیت"
                  label-for="Status"
                >
                  <v-select
                    v-model="filterOptions.Status"
                    :options="statusOptions"
                    dir="rtl"
                    label="text"
                    :reduce="x => x.value"
                  />
                </b-form-group>
              </b-col>
              <b-col md="2">
                <b-form-group
                  label="تیک آبی"
                  label-for="IsVerified"
                >
                  <v-select
                    v-model="filterOptions.IsVerified"
                    :options="verifiedOptions"
                    dir="rtl"
                    label="text"
                    :reduce="x => x.value"
                  />
                </b-form-group>
              </b-col>
              <b-button
                v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                class="mb-1 mr-1"
                variant="warning"
                @click="update(1)"
              >فیلتر
              </b-button>
            </div>
          </b-row>
        </div>

        <b-table
          bordered
          hover
          striped
          :items="items"
          :fields="fields"
          class="mt-1 mb-2 position-relative"
          responsive
          :busy="loading"
        >
          <template #cell(Id)="data">
            <b-link
              class="font-weight-bold"
              @click="openDetails(data.item.Id)"
            >
              #{{ data.value }}
            </b-link>
          </template>

          <template #cell(Image)="data">
            <b-avatar
              :src="data.value"
              size="40"
              rounded
            />
          </template>

          <template #cell(FullName)="data">
            <div class="d-flex align-items-center">
              <span>{{ data.item.Name }} {{ data.item.Family }}</span>
              <feather-icon
                v-if="data.item.IsVerified"
                icon="CheckCircleIcon"
                size="16"
                class="ml-50 text-primary"
              />
            </div>
          </template>

          <template #cell(CityTitle)="data">
            <span>{{ data.value || '—' }}</span>
          </template>

          <template #cell(Status)="data">
            <b-badge :variant="statusVariant(data.value)">
              {{ statusText(data.value) }}
            </b-badge>
          </template>

          <template #cell(actions)="data">
            <div class="text-nowrap">
              <feather-icon
                icon="EyeIcon"
                size="16"
                class="cursor-pointer"
                @click="openDetails(data.item.Id)"
              />
              <feather-icon
                icon="TrashIcon"
                size="16"
                class="ml-1 cursor-pointer text-danger"
                @click="remove(data.item.Id)"
              />
            </div>
          </template>

          <template #table-busy>
            <div class="text-center my-2">
              <b-spinner
                variant="primary"
                class="align-middle"
              />
              <strong class="ml-1">در حال دریافت اطلاعات ...</strong>
            </div>
          </template>
        </b-table>

        <z-pagination
          :page="filterOptions.Page"
          :per-page.sync="filterOptions.PerPage"
          :total-rows="totalRows"
          :loading="loading"
          @change="update"
        />
      </b-col>
    </b-row>

    <!-- مدال جزئیات -->
    <b-modal
      v-if="showModal"
      v-model="showModal"
      centered
      hide-footer
      title="جزئیات مشاور"
      :no-close-on-backdrop="true"
      size="lg"
    >
      <div
        v-if="detailLoading"
        class="text-center my-3"
      >
        <b-spinner variant="primary" />
      </div>

      <div v-else-if="detail">
        <b-row>
          <b-col
            md="3"
            class="text-center mb-2"
          >
            <b-avatar
              :src="detail.Image"
              size="100"
              rounded
            />
            <div class="mt-1">
              <b-badge :variant="statusVariant(detail.Status)">
                {{ statusText(detail.Status) }}
              </b-badge>
            </div>
            <div class="mt-1">
              <b-badge :variant="detail.IsVerified ? 'primary' : 'secondary'">
                {{ detail.IsVerified ? 'دارای تیک آبی' : 'بدون تیک آبی' }}
              </b-badge>
            </div>
          </b-col>

          <b-col md="9">
            <b-row>
              <b-col
                md="6"
                class="mb-1"
              >
                <small class="text-muted">نام و نام خانوادگی</small>
                <div class="font-weight-bold">{{ detail.Name }} {{ detail.Family }}</div>
              </b-col>
              <b-col
                md="6"
                class="mb-1"
              >
                <small class="text-muted">موبایل کاربر</small>
                <div class="font-weight-bold">{{ detail.User ? detail.User.Mobile : '—' }}</div>
              </b-col>
              <b-col
                md="6"
                class="mb-1"
              >
                <small class="text-muted">کد ملی</small>
                <div class="font-weight-bold">{{ detail.NationalCode || '—' }}</div>
              </b-col>
              <b-col
                md="6"
                class="mb-1"
              >
                <small class="text-muted">محل فعالیت</small>
                <div class="font-weight-bold">{{ cityText(detail) }}</div>
              </b-col>
              <b-col
                md="6"
                class="mb-1"
              >
                <small class="text-muted">درصد کمیسیون</small>
                <div class="font-weight-bold">{{ detail.CommissionPercent != null ? detail.CommissionPercent + '٪' : 'پیش‌فرض' }}</div>
              </b-col>
              <b-col
                md="6"
                class="mb-1"
              >
                <small class="text-muted">بازدید</small>
                <div class="font-weight-bold">{{ detail.Visit || 0 }}</div>
              </b-col>
            </b-row>
          </b-col>

          <b-col
            md="12"
            class="mb-1"
          >
            <small class="text-muted">تخصص‌ها</small>
            <div class="mt-25">
              <b-badge
                v-for="s in detail.Specialties"
                :key="s.ConsultingCategoryId"
                variant="light-info"
                class="mr-50 mb-50"
              >{{ s.Title }}</b-badge>
              <span v-if="!detail.Specialties || !detail.Specialties.length">—</span>
            </div>
          </b-col>

          <b-col
            md="12"
            class="mb-1"
          >
            <small class="text-muted">روش‌ها و قیمت</small>
            <div class="mt-25">
              <b-badge
                v-for="m in detail.Methods"
                :key="m.Method"
                variant="light-success"
                class="mr-50 mb-50"
              >{{ methodText(m.Method) }}: {{ m.DurationMinutes }} دقیقه - {{ money(m.Price) }} تومان</b-badge>
              <span v-if="!detail.Methods || !detail.Methods.length">—</span>
            </div>
          </b-col>

          <b-col
            md="12"
            class="mb-1"
          >
            <small class="text-muted">برنامه‌ی هفتگی</small>
            <div class="mt-25">
              <div
                v-for="day in groupedAvailabilities"
                :key="day.day"
                class="small"
              >
                <b>{{ dayText(day.day) }}:</b>
                <span
                  v-for="(r, i) in day.ranges"
                  :key="i"
                  dir="ltr"
                  class="mr-50"
                >{{ hm(r.StartTime) }}–{{ hm(r.EndTime) }}</span>
              </div>
              <span v-if="!detail.Availabilities || !detail.Availabilities.length">—</span>
            </div>
          </b-col>

          <b-col
            v-if="detail.Exceptions && detail.Exceptions.length"
            md="12"
            class="mb-1"
          >
            <small class="text-muted">استثناهای تقویمی</small>
            <div class="mt-25">
              <div
                v-for="(e, i) in detail.Exceptions"
                :key="i"
                class="small"
              >
                <span>{{ e.Date | date }}</span>
                <b-badge
                  :variant="e.IsBlocked ? 'light-danger' : 'light-success'"
                  class="mr-50"
                >{{ e.IsBlocked ? 'مسدود' : 'بازه‌ی اضافه' }}</b-badge>
                <span
                  v-if="e.StartTime"
                  dir="ltr"
                >{{ hm(e.StartTime) }}–{{ hm(e.EndTime) }}</span>
              </div>
            </div>
          </b-col>

          <b-col
            v-if="detail.Address"
            md="12"
            class="mb-1"
          >
            <small class="text-muted">آدرس (حضوری)</small>
            <div>{{ detail.Address }}</div>
          </b-col>

          <b-col
            v-if="detail.Description"
            md="12"
            class="mb-1"
          >
            <small class="text-muted">توضیحات</small>
            <div>{{ detail.Description }}</div>
          </b-col>

          <b-col
            md="12"
            class="mb-1"
          >
            <small class="text-muted">مدارک هویتی و گواهی</small>
            <div
              v-if="detail.Documents && detail.Documents.length"
              class="doc-gallery mt-25"
            >
              <a
                v-for="doc in detail.Documents"
                :key="doc.Id"
                :href="doc.File"
                target="_blank"
                class="doc-thumb"
              >
                <img :src="doc.File">
              </a>
            </div>
            <div
              v-else
              class="text-muted"
            >مدرکی بارگذاری نشده است</div>
          </b-col>

          <b-col
            v-if="detail.Status === 2 && detail.RejectReason"
            md="12"
            class="mb-1"
          >
            <small class="text-muted">دلیل رد</small>
            <div class="text-danger">{{ detail.RejectReason }}</div>
          </b-col>
        </b-row>

        <hr>

        <div class="d-flex flex-wrap justify-content-end">
          <b-button
            variant="outline-primary"
            class="mr-1 mb-1"
            @click="openEdit"
          >
            <feather-icon
              icon="EditIcon"
              class="mr-25"
            />
            ویرایش
          </b-button>
          <b-button
            variant="outline-secondary"
            class="mr-1 mb-1"
            @click="toggleVerified"
          >
            <feather-icon
              icon="CheckCircleIcon"
              class="mr-25"
            />
            {{ detail.IsVerified ? 'حذف تیک آبی' : 'اعطای تیک آبی' }}
          </b-button>
          <b-button
            v-if="detail.Status !== 2"
            variant="outline-danger"
            class="mr-1 mb-1"
            @click="openReject"
          >
            رد درخواست
          </b-button>
          <b-button
            v-if="detail.Status !== 1"
            variant="success"
            class="mb-1"
            @click="accept"
          >
            تأیید
          </b-button>
        </div>
      </div>
    </b-modal>

    <!-- مدال رد با دلیل -->
    <b-modal
      v-if="showReject"
      v-model="showReject"
      centered
      ok-title="ثبت رد"
      cancel-title="انصراف"
      ok-variant="danger"
      cancel-variant="outline-secondary"
      title="رد درخواست مشاور"
      :no-close-on-backdrop="true"
      @ok="reject"
    >
      <b-form-group
        label="دلیل رد (به کاربر نمایش داده می‌شود)"
        label-for="RejectReason"
      >
        <b-form-textarea
          v-model="rejectReason"
          rows="3"
          no-resize
          placeholder="مثلاً مدارک ناقص است…"
        />
      </b-form-group>
    </b-modal>

    <!-- مدال افزودن / ویرایش -->
    <b-modal
      v-if="showForm"
      v-model="showForm"
      ok-title="ذخیره"
      cancel-title="انصراف"
      cancel-variant="outline-secondary"
      centered
      :title="form.Id ? 'ویرایش مشاور' : 'افزودن مشاور'"
      :no-close-on-backdrop="true"
      size="lg"
      @ok.prevent="save"
    >
      <b-row>
        <b-col
          md="3"
          class="text-center mb-2"
        >
          <input
            ref="refImage"
            type="file"
            class="d-none"
            accept="image/*"
            @change="imageRenderer($event)"
          >
          <label style="font-weight: 600; display: block">تصویر</label>
          <div
            class="order-upload mx-auto"
            @click="$refs.refImage.click()"
          >
            <img
              v-if="form.Image"
              :src="form.Image"
            >
            <div v-else>
              <feather-icon
                size="24"
                icon="UploadIcon"
              />
            </div>
          </div>
        </b-col>

        <b-col md="9">
          <b-row>
            <b-col
              v-if="!form.Id"
              md="6"
            >
              <b-form-group
                label="موبایل کاربر"
                label-for="Mobile"
              >
                <b-form-input
                  v-model="form.Mobile"
                  autocomplete="off"
                  placeholder="09xxxxxxxxx"
                />
              </b-form-group>
            </b-col>

            <b-col md="6">
              <b-form-group
                label="نام"
                label-for="Name"
              >
                <b-form-input
                  v-model="form.Name"
                  autocomplete="off"
                />
              </b-form-group>
            </b-col>

            <b-col md="6">
              <b-form-group
                label="نام خانوادگی"
                label-for="Family"
              >
                <b-form-input
                  v-model="form.Family"
                  autocomplete="off"
                />
              </b-form-group>
            </b-col>

            <b-col md="6">
              <b-form-group
                label="کد ملی"
                label-for="NationalCode"
              >
                <b-form-input
                  v-model="form.NationalCode"
                  autocomplete="off"
                />
              </b-form-group>
            </b-col>

            <b-col md="6">
              <b-form-group
                label="تاریخ تولد"
                label-for="Birthday"
              >
                <date-picker
                  v-model="form.Birthday"
                  placeholder=""
                />
              </b-form-group>
            </b-col>
          </b-row>
        </b-col>

        <b-col md="6">
          <b-form-group
            label="استان"
            label-for="StateId"
          >
            <z-state
              v-model="form.StateId"
              :clearable="true"
              @input="onStateChange"
            />
          </b-form-group>
        </b-col>

        <b-col md="6">
          <b-form-group
            label="شهر"
            label-for="CityId"
          >
            <v-select
              v-model="form.CityId"
              dir="rtl"
              label="Title"
              :reduce="x => x.Id"
              :options="cityOptions"
              :loading="cityLoading"
              :disabled="!form.StateId"
              :placeholder="form.StateId ? 'انتخاب شهر' : 'ابتدا استان را انتخاب کنید'"
            >
              <span slot="no-options">موردی یافت نشد</span>
            </v-select>
          </b-form-group>
        </b-col>

        <b-col md="6">
          <b-form-group
            label="تخصص‌ها"
            label-for="SpecialtyId"
          >
            <z-consulting-category
              v-model="form.SpecialtyId"
              :multiple="true"
              :clearable="true"
            />
          </b-form-group>
        </b-col>

        <b-col md="6">
          <b-form-group
            label="درصد کمیسیون (خالی = پیش‌فرض)"
            label-for="CommissionPercent"
          >
            <b-form-input
              v-model.number="form.CommissionPercent"
              type="number"
              step="0.1"
              autocomplete="off"
              placeholder="مثلاً ۱۵"
            />
          </b-form-group>
        </b-col>

        <!-- روش‌ها و قیمت -->
        <b-col md="12">
          <label style="font-weight: 600; display: block" class="mb-50">روش‌های مشاوره</label>
          <div
            v-for="m in methodDefs"
            :key="m.value"
            class="method-row"
          >
            <b-form-checkbox
              v-model="form.Methods[m.value].enabled"
              class="method-check"
            >
              {{ m.text }}
            </b-form-checkbox>
            <b-form-input
              v-model.number="form.Methods[m.value].duration"
              type="number"
              size="sm"
              class="method-input"
              :disabled="!form.Methods[m.value].enabled"
              placeholder="مدت (دقیقه)"
            />
            <b-form-input
              v-model.number="form.Methods[m.value].price"
              type="number"
              size="sm"
              class="method-input"
              :disabled="!form.Methods[m.value].enabled"
              placeholder="قیمت (تومان)"
            />
          </div>
        </b-col>

        <b-col md="12">
          <b-form-group
            label="آدرس محل (برای روش حضوری لازم است)"
            label-for="Address"
          >
            <b-form-input
              v-model="form.Address"
              autocomplete="off"
            />
          </b-form-group>
        </b-col>

        <!-- برنامه‌ی هفتگی -->
        <b-col md="12">
          <label style="font-weight: 600; display: block" class="mb-50">برنامه‌ی زمانی هفتگی</label>
          <div
            v-for="day in dayDefs"
            :key="day.value"
            class="avail-day"
          >
            <div class="avail-day-head">
              <span>{{ day.text }}</span>
              <b-button
                size="sm"
                variant="flat-primary"
                @click="addRange(day.value)"
              >
                <feather-icon icon="PlusIcon" />
                بازه
              </b-button>
            </div>
            <div
              v-for="(r, i) in form.Availabilities[day.value]"
              :key="i"
              class="avail-range"
            >
              <b-form-input
                v-model="r.start"
                type="time"
                size="sm"
              />
              <span class="mx-50">تا</span>
              <b-form-input
                v-model="r.end"
                type="time"
                size="sm"
              />
              <feather-icon
                icon="XIcon"
                size="16"
                class="ml-50 cursor-pointer text-danger"
                @click="removeRange(day.value, i)"
              />
            </div>
          </div>
        </b-col>

        <!-- استثناها -->
        <b-col md="12">
          <div class="d-flex align-items-center justify-content-between mb-50">
            <label style="font-weight: 600; margin: 0">استثناهای تقویمی</label>
            <b-button
              size="sm"
              variant="flat-primary"
              @click="addException"
            >
              <feather-icon icon="PlusIcon" />
              استثنا
            </b-button>
          </div>
          <div
            v-for="(e, i) in form.Exceptions"
            :key="i"
            class="exc-row"
          >
            <date-picker
              v-model="e.Date"
              placeholder="تاریخ"
              class="exc-date"
            />
            <v-select
              v-model="e.Mode"
              :options="excModeOptions"
              dir="rtl"
              label="text"
              :clearable="false"
              :reduce="x => x.value"
              class="exc-mode"
            />
            <b-form-input
              v-if="e.Mode !== 'block-day'"
              v-model="e.StartTime"
              type="time"
              size="sm"
              class="exc-time"
            />
            <b-form-input
              v-if="e.Mode !== 'block-day'"
              v-model="e.EndTime"
              type="time"
              size="sm"
              class="exc-time"
            />
            <feather-icon
              icon="XIcon"
              size="16"
              class="ml-50 cursor-pointer text-danger"
              @click="removeException(i)"
            />
          </div>
        </b-col>

        <!-- مدارک -->
        <b-col md="12">
          <b-form-group
            label="مدارک هویتی و گواهی (فقط برای بررسی)"
            label-for="Documents"
          >
            <input
              ref="refDocs"
              type="file"
              class="d-none"
              accept="image/*"
              multiple
              @change="docsRenderer($event)"
            >
            <div class="doc-edit-grid">
              <div
                v-for="doc in existingDocuments"
                :key="`e-${doc.Id}`"
                class="doc-edit-item"
              >
                <img :src="doc.File">
                <span
                  class="doc-del"
                  @click="removeExistingDoc(doc.Id)"
                >
                  <feather-icon
                    icon="XIcon"
                    size="14"
                  />
                </span>
              </div>
              <div
                v-for="(src, i) in newDocumentPreviews"
                :key="`n-${i}`"
                class="doc-edit-item new"
              >
                <img :src="src">
                <span
                  class="doc-del"
                  @click="removeNewDoc(i)"
                >
                  <feather-icon
                    icon="XIcon"
                    size="14"
                  />
                </span>
              </div>
              <div
                class="doc-edit-add"
                @click="$refs.refDocs.click()"
              >
                <feather-icon
                  icon="PlusIcon"
                  size="22"
                />
                <span>افزودن</span>
              </div>
            </div>
          </b-form-group>
        </b-col>

        <b-col md="12">
          <b-form-group
            label="توضیحات"
            label-for="Description"
          >
            <b-form-textarea
              v-model="form.Description"
              rows="3"
              no-resize
            />
          </b-form-group>
        </b-col>
      </b-row>
    </b-modal>
  </b-card>
</template>

<script>

import ZState from '@/tools/state.vue'
import ZConsultingCategory from '@/tools/consultingcategory.vue'

export default {
  name: 'ConsultingProfile',
  components: { ZState, ZConsultingCategory },
  data() {
    return {
      totalRows: 1000 * 1000,
      loading: false,
      filterOptions: {
        Title: null,
        Mobile: null,
        Status: null,
        IsVerified: null,
        Page: 1,
        PerPage: 10,
      },
      statusOptions: [
        { text: 'در انتظار بررسی', value: 0 },
        { text: 'تأییدشده', value: 1 },
        { text: 'ردشده', value: 2 },
      ],
      verifiedOptions: [
        { text: 'دارد', value: true },
        { text: 'ندارد', value: false },
      ],
      methodDefs: [
        { value: 0, text: 'تماس تلفنی' },
        { value: 1, text: 'تماس تصویری' },
        { value: 2, text: 'چت متنی' },
        { value: 3, text: 'حضوری' },
      ],
      dayDefs: [
        { value: 0, text: 'شنبه' },
        { value: 1, text: 'یکشنبه' },
        { value: 2, text: 'دوشنبه' },
        { value: 3, text: 'سه‌شنبه' },
        { value: 4, text: 'چهارشنبه' },
        { value: 5, text: 'پنجشنبه' },
        { value: 6, text: 'جمعه' },
      ],
      excModeOptions: [
        { text: 'مسدود کل روز', value: 'block-day' },
        { text: 'مسدود کردن بازه', value: 'block-range' },
        { text: 'افزودن بازه', value: 'add-range' },
      ],
      showModal: false,
      showReject: false,
      showForm: false,
      form: {},
      detailLoading: false,
      detail: null,
      rejectReason: null,
      cityOptions: [],
      cityLoading: false,
      existingDocuments: [],
      removeDocumentId: [],
      newDocuments: [],
      newDocumentPreviews: [],
      fields: [
        { key: 'Id', label: '#', thClass: 'col-width-50' },
        { key: 'Image', label: 'عکس', thClass: 'col-width-50' },
        { key: 'FullName', label: 'نام' },
        { key: 'Mobile', label: 'موبایل' },
        { key: 'CityTitle', label: 'شهر' },
        { key: 'SpecialtyCount', label: 'تخصص' },
        { key: 'MethodCount', label: 'روش' },
        { key: 'Status', label: 'وضعیت' },
        { key: 'actions', label: '', thClass: 'col-width-50' },
      ],
      items: [],
    }
  },
  computed: {
    groupedAvailabilities() {
      const map = {}
      ;(this.detail && this.detail.Availabilities ? this.detail.Availabilities : []).forEach(a => {
        if (!map[a.DayOfWeek]) map[a.DayOfWeek] = []
        map[a.DayOfWeek].push(a)
      })
      return Object.keys(map)
        .map(d => ({ day: Number(d), ranges: map[d] }))
        .sort((a, b) => a.day - b.day)
    },
  },
  created() {
    if (this.$store.state.zirehState.listFilter[this.$options.name]) {
      this.filterOptions = this.$store.state.zirehState.listFilter[this.$options.name]
    }
    this.update()
  },
  methods: {
    money(value) {
      if (value == null) return '۰'
      return Number(value).toLocaleString('fa-IR')
    },
    hm(value) {
      return value ? String(value).slice(0, 5) : ''
    },
    methodText(value) {
      return ['تماس تلفنی', 'تماس تصویری', 'چت متنی', 'حضوری'][value] || '—'
    },
    dayText(value) {
      return ['شنبه', 'یکشنبه', 'دوشنبه', 'سه‌شنبه', 'چهارشنبه', 'پنجشنبه', 'جمعه'][value] || '—'
    },
    statusText(value) {
      return ['در انتظار بررسی', 'تأییدشده', 'ردشده'][value] || '—'
    },
    statusVariant(value) {
      return ['light-warning', 'light-success', 'light-danger'][value] || 'light-secondary'
    },
    cityText(detail) {
      if (!detail || !detail.City) return '—'
      return [detail.City.StateTitle, detail.City.Title].filter(Boolean).join('، ')
    },
    update(pageNumber) {
      this.loading = true
      this.filterOptions.Page = pageNumber || this.filterOptions.Page
      this.$store.commit('zirehState/setListFilter', { key: this.$options.name, value: this.filterOptions })

      this.$http.post(this.$api.consultingprofile.getlist, this.filterOptions)
        .then(res => {
          this.totalRows = res.totalRow
          this.items = res.data
        })
        .finally(() => {
          this.loading = false
        })
    },
    openDetails(id) {
      this.showModal = true
      this.detail = null
      this.detailLoading = true
      this.$http.post(this.$api.consultingprofile.get, { Id: id })
        .then(res => {
          this.detail = res.data
        })
        .finally(() => {
          this.detailLoading = false
        })
    },
    accept() {
      this.$http.post(this.$api.consultingprofile.accept, { Id: this.detail.Id })
        .then(() => {
          this.showModal = false
          this.update()
        })
    },
    openReject() {
      this.rejectReason = this.detail.RejectReason || null
      this.showReject = true
    },
    reject() {
      this.$http.post(this.$api.consultingprofile.reject, { Id: this.detail.Id, RejectReason: this.rejectReason })
        .then(() => {
          this.showModal = false
          this.update()
        })
    },
    toggleVerified() {
      this.$http.post(this.$api.consultingprofile.setverified, { Id: this.detail.Id, IsVerified: !this.detail.IsVerified })
        .then(() => {
          this.detail.IsVerified = !this.detail.IsVerified
          this.update()
        })
    },
    remove(id) {
      this.removeRow(this.$api.consultingprofile.remove, 'Id', id)
    },
    resetDocs() {
      this.existingDocuments = []
      this.removeDocumentId = []
      this.newDocuments = []
      this.newDocumentPreviews = []
    },
    emptyMethods() {
      const methods = {}
      this.methodDefs.forEach(m => {
        methods[m.value] = { enabled: false, duration: 30, price: 0 }
      })
      return methods
    },
    emptyAvailabilities() {
      const avail = {}
      this.dayDefs.forEach(d => {
        avail[d.value] = []
      })
      return avail
    },
    openAdd() {
      this.form = {
        Mobile: null,
        Name: null,
        Family: null,
        Image: null,
        NationalCode: null,
        Birthday: null,
        StateId: null,
        CityId: null,
        SpecialtyId: [],
        CommissionPercent: null,
        Address: null,
        Description: null,
        Methods: this.emptyMethods(),
        Availabilities: this.emptyAvailabilities(),
        Exceptions: [],
      }
      this.cityOptions = []
      this.resetDocs()
      this.showForm = true
    },
    openEdit() {
      const d = this.detail

      const methods = this.emptyMethods()
      ;(d.Methods || []).forEach(m => {
        if (methods[m.Method]) {
          methods[m.Method] = { enabled: true, duration: m.DurationMinutes, price: m.Price }
        }
      })

      const avail = this.emptyAvailabilities()
      ;(d.Availabilities || []).forEach(a => {
        if (!avail[a.DayOfWeek]) avail[a.DayOfWeek] = []
        avail[a.DayOfWeek].push({ start: this.hm(a.StartTime), end: this.hm(a.EndTime) })
      })

      const exceptions = (d.Exceptions || []).map(e => {
        let mode = 'add-range'
        if (e.IsBlocked) mode = e.StartTime ? 'block-range' : 'block-day'
        return {
          Date: e.Date ? String(e.Date).slice(0, 10) : null,
          Mode: mode,
          StartTime: this.hm(e.StartTime),
          EndTime: this.hm(e.EndTime),
        }
      })

      this.form = {
        Id: d.Id,
        Name: d.Name,
        Family: d.Family,
        Image: d.Image,
        NationalCode: d.NationalCode,
        Birthday: d.Birthday ? String(d.Birthday).slice(0, 10) : null,
        StateId: d.City ? d.City.StateId : null,
        CityId: d.CityId,
        SpecialtyId: (d.Specialties || []).map(s => s.ConsultingCategoryId),
        CommissionPercent: d.CommissionPercent,
        Address: d.Address,
        Description: d.Description,
        Methods: methods,
        Availabilities: avail,
        Exceptions: exceptions,
      }
      this.resetDocs()
      this.existingDocuments = (d.Documents || []).slice()
      this.cityOptions = []
      if (this.form.StateId) this.loadCities(this.form.StateId, false)
      this.showModal = false
      this.showForm = true
    },
    addRange(day) {
      this.form.Availabilities[day].push({ start: '09:00', end: '12:00' })
    },
    removeRange(day, index) {
      this.form.Availabilities[day].splice(index, 1)
    },
    addException() {
      this.form.Exceptions.push({ Date: null, Mode: 'block-day', StartTime: null, EndTime: null })
    },
    removeException(index) {
      this.form.Exceptions.splice(index, 1)
    },
    loadCities(stateId, reset = true) {
      if (!stateId) {
        this.cityOptions = []
        return
      }
      this.cityLoading = true
      this.$http.post(this.$api.city.getall, { StateId: stateId })
        .then(res => {
          this.cityOptions = res.data
          if (reset) this.form.CityId = null
        })
        .finally(() => {
          this.cityLoading = false
        })
    },
    onStateChange(stateId) {
      this.loadCities(stateId, true)
    },
    docsRenderer(event) {
      const files = Array.from(event.target.files || [])
      files.forEach(file => {
        if (!file.type.startsWith('image/')) return
        this.newDocuments.push(file)
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = () => {
          this.newDocumentPreviews.push(reader.result)
        }
      })
      event.target.value = ''
    },
    removeNewDoc(index) {
      this.newDocuments.splice(index, 1)
      this.newDocumentPreviews.splice(index, 1)
    },
    removeExistingDoc(id) {
      this.removeDocumentId.push(id)
      this.existingDocuments = this.existingDocuments.filter(d => d.Id !== id)
    },
    save() {
      const url = this.form.Id ? this.$api.consultingprofile.update : this.$api.consultingprofile.add

      const formData = new FormData()

      if (this.form.Id) {
        formData.append('Id', this.form.Id)
      } else {
        formData.append('Mobile', this.form.Mobile || '')
      }

      formData.append('Name', this.form.Name || '')
      formData.append('Family', this.form.Family || '')
      formData.append('NationalCode', this.form.NationalCode || '')

      if (this.form.Birthday) formData.append('Birthday', this.form.Birthday)
      if (this.form.CityId) formData.append('CityId', this.form.CityId)
      if (this.form.Address) formData.append('Address', this.form.Address)
      if (this.form.Description) formData.append('Description', this.form.Description)
      if (this.form.CommissionPercent !== null && this.form.CommissionPercent !== '') {
        formData.append('CommissionPercent', this.form.CommissionPercent)
      }

      ;(this.form.SpecialtyId || []).forEach(id => {
        formData.append('SpecialtyId', id)
      })

      let mIdx = 0
      this.methodDefs.forEach(m => {
        const mm = this.form.Methods[m.value]
        if (mm && mm.enabled) {
          formData.append(`Methods[${mIdx}].Method`, m.value)
          formData.append(`Methods[${mIdx}].DurationMinutes`, mm.duration || 0)
          formData.append(`Methods[${mIdx}].Price`, mm.price || 0)
          mIdx += 1
        }
      })

      let aIdx = 0
      this.dayDefs.forEach(d => {
        (this.form.Availabilities[d.value] || []).forEach(r => {
          if (r.start && r.end) {
            formData.append(`Availabilities[${aIdx}].DayOfWeek`, d.value)
            formData.append(`Availabilities[${aIdx}].StartTime`, r.start)
            formData.append(`Availabilities[${aIdx}].EndTime`, r.end)
            aIdx += 1
          }
        })
      })

      let eIdx = 0
      this.form.Exceptions.forEach(e => {
        if (!e.Date) return
        const isBlocked = e.Mode === 'block-day' || e.Mode === 'block-range'
        formData.append(`Exceptions[${eIdx}].Date`, e.Date)
        formData.append(`Exceptions[${eIdx}].IsBlocked`, isBlocked)
        if (e.Mode !== 'block-day') {
          if (e.StartTime) formData.append(`Exceptions[${eIdx}].StartTime`, e.StartTime)
          if (e.EndTime) formData.append(`Exceptions[${eIdx}].EndTime`, e.EndTime)
        }
        eIdx += 1
      })

      this.newDocuments.forEach(file => {
        formData.append('Documents', file)
      })

      this.removeDocumentId.forEach(id => {
        formData.append('RemoveDocumentId', id)
      })

      const image = this.$refs.refImage.files[0]
      if (image) {
        formData.append('Image', image)
      }

      this.$http.post(url, formData)
        .then(() => {
          this.showForm = false
          this.update()
        })
    },
    imageRenderer(event) {
      const fileReader = new FileReader()
      fileReader.readAsDataURL(event.target.files[0])
      fileReader.onload = () => {
        this.$set(this.form, 'Image', fileReader.result)
      }
    },
  },
}
</script>

<style>
.order-upload {
  align-items: center;
  display: flex;
  height: 112px;
  justify-content: center;
  width: 112px;
  text-align: center;
  border: 1px solid #dbdade;
  cursor: pointer;
  border-radius: 0.357rem;
  flex-direction: column;
  margin-bottom: 1rem;
}

.order-upload img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 0.357rem;
}

.method-row {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 8px;
}

.method-check {
  min-width: 110px;
}

.method-input {
  max-width: 160px;
}

.avail-day {
  border: 1px solid #ebe9f1;
  border-radius: 0.357rem;
  padding: 8px 10px;
  margin-bottom: 8px;
}

.avail-day-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-weight: 600;
}

.avail-range {
  display: flex;
  align-items: center;
  margin-top: 6px;
  max-width: 320px;
}

.exc-row {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
  flex-wrap: wrap;
}

.exc-date {
  max-width: 150px;
}

.exc-mode {
  min-width: 160px;
}

.exc-time {
  max-width: 120px;
}

.doc-gallery {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.doc-thumb {
  display: block;
  width: 90px;
  height: 90px;
  border-radius: 0.357rem;
  overflow: hidden;
  border: 1px solid #dbdade;
}

.doc-thumb img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.doc-edit-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.doc-edit-item {
  position: relative;
  width: 92px;
  height: 92px;
  border-radius: 0.357rem;
  overflow: hidden;
  border: 1px solid #dbdade;
}

.doc-edit-item.new {
  border-color: #7367f0;
}

.doc-edit-item img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.doc-del {
  position: absolute;
  top: 4px;
  left: 4px;
  width: 22px;
  height: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.55);
  color: #fff;
  border-radius: 50%;
  cursor: pointer;
}

.doc-edit-add {
  width: 92px;
  height: 92px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  border: 1.5px dashed #c3ccd6;
  border-radius: 0.357rem;
  color: #6e6b7b;
  cursor: pointer;
  font-size: 0.8rem;
}

.doc-edit-add:hover {
  border-color: #7367f0;
  color: #7367f0;
}
</style>
